<script setup>
import {inject, ref} from "vue";
import AppBar from "./layout/AppBar.vue";
import NavigationDrawer from "./layout/NavigationDrawer.vue";
import {md} from "@/utils/breakpoints";

const drawer = ref(false)
const hpoMember = inject('hpoMember', undefined)
</script>

<template>
    <v-app>
        <NavigationDrawer v-model:drawer="drawer" :hpoMember="hpoMember">
            <div v-if="!md" class="mb-6">
                <slot name="nav-controls"></slot>
            </div>
        </NavigationDrawer>
        <AppBar v-model:drawer="drawer" :hpoMember="hpoMember">
            <template v-if="md">
                <slot name="nav-controls"></slot>
            </template>
        </AppBar>
        <v-main>
            <slot></slot>
        </v-main>
    </v-app>
</template>